import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import Index from './views/Index.vue'
import Details from './views/Details.vue'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/index/:parkCode?',
      name: 'index',
      component: Index
    },
    {
      path: '/details/:parkCode/:fieldCode?',
      name: 'details',
      component: Details
    }
  ]
})

router.beforeEach((to, from, next) => {
  if(to.path=='/'){
    store.commit('clearIndex')
    next('/index')
  } else
    next()
})

export default router